import React from 'react';
import PropTypes from 'prop-types';
import { Tiles } from 'wsm-tiles';

const CustomOverlayContent = ({ tileData, onClose }) => {
	return (
		<div
			className="custom-overlay-wrapper position-relative overflow-hidden"
			data-testid="custom-overlay-wrapper"
		>
			<button
				className="overlay-close-btn position-absolute rounded-circle p-0 d-flex align-items-center justify-content-center"
				aria-label="Close"
				onClick={onClose}
				type="button"
			>
				<svg
					width="16"
					height="16"
					viewBox="0 0 16 16"
					fill="none"
					data-testid="close-icon"
				>
					<path
						d="M12 4L4 12M4 4L12 12"
						stroke="currentColor"
						strokeWidth="2"
						strokeLinecap="round"
					/>
				</svg>
			</button>
			<Tiles
				type="location"
				data={tileData}
				layout="grid"
				className="justify-content-center"
			/>
		</div>
	);
};

CustomOverlayContent.propTypes = {
	tileData: PropTypes.arrayOf(PropTypes.object).isRequired,
	onClose: PropTypes.func.isRequired
};

export default CustomOverlayContent;
